import { render, staticRenderFns } from "./Currencies.vue?vue&type=template&id=19e3676e&scoped=true&"
import script from "./Currencies.vue?vue&type=script&lang=js&"
export * from "./Currencies.vue?vue&type=script&lang=js&"
import style0 from "./Currencies.vue?vue&type=style&index=0&id=19e3676e&lang=scss&scoped=true&"
import style1 from "./Currencies.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e3676e",
  null
  
)

export default component.exports